import _ from 'lodash'

import {
  LIST_USER_LOGS_STARTED,
  LIST_USER_LOGS_COMPLETED,
  LIST_USER_LOGS_FAILED,
  CLEAR_STATES
} from '@/store/types'
import { marshalAuditLog } from '@/utils/marshal'

function getDefaultState () {
  return {
    logs: [],
    prevPageToken: '',
    nextPageToken: '',
    totalItems: -1,
    currentPage: 1,

    loading: false,
    error: undefined,
    actionError: undefined
  }
}

export default {
  namespaced: true,
  modules: {},

  state: getDefaultState(),
  getters: {},

  mutations: {
    // List user logs
    [LIST_USER_LOGS_STARTED] (state) {
      state.loading = true
    },
    [LIST_USER_LOGS_COMPLETED] (state, logsObj, pageNumber, ascending) {
      state.logs = logsObj.audit_logs.map(marshalAuditLog)
      if (ascending) {
        state.nextPageToken = state.prevPageToken
        state.prevPageToken = _.cloneDeep(logsObj.next_page_token)
      } else {
        state.prevPageToken = state.nextPageToken
        state.nextPageToken = _.cloneDeep(logsObj.next_page_token)
      }
      state.currentPage = pageNumber
      state.totalItems = logsObj.total_size

      state.loading = false
      state.error = undefined
    },
    [LIST_USER_LOGS_FAILED] (state, err) {
      state.loading = false
      state.error = err
    },

    // Clear states
    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async list ({ commit, rootState: { client = undefined, management } }, payload) {
      const { rowsPerPage, pageToken, ascending, pageNumber } = payload
      try {
        commit(LIST_USER_LOGS_STARTED)
        const { id: userId } = management.userDetails.user
        const logsObj = await client.managementClient.listUserAuditLogs(userId, rowsPerPage, pageToken, ascending)
        commit(LIST_USER_LOGS_COMPLETED, logsObj, pageNumber, true)
      } catch (err) {
        commit(LIST_USER_LOGS_FAILED, err)
      }
    }
  }
}
